import { useRef, useState } from "react";
import type { TemplateSettingsState } from "./use-settings-state";

/** Whole-list saves cannot overlap: a late response would restore an older order. */
export const useRuleOrder = (state: TemplateSettingsState) => {
  const pending = useRef(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");
  const saveOrder = async (order: string[] | null) => {
    if (!state.editable || state.saving || pending.current) return;
    pending.current = true;
    setSaving(true);
    setMessage("Saving review order…");
    try {
      await state.save({ rule_order: order });
      setMessage(
        order ? "Review order saved." : "Automatic review order restored.",
      );
    } catch {
      setMessage("Order was not saved. Previous order restored. Try again.");
    } finally {
      pending.current = false;
      setSaving(false);
    }
  };
  return { saveOrder, busy: state.saving || saving, message };
};
